export default __webpack_public_path__ + "static/media/How much will it cost.e8f1e009.mp3";